<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { AutoDateDefinition } from 'header/types';

    interface Props {
        field: AutoDateDefinition;
    }

    let { field }: Props = $props();

    let fromOffset = $derived(field.value?.from.offset);
    let toOffset = $derived(field.value?.to?.offset);
    let isEnabled = $derived(!!field.value);
    let isRange = $derived(!!field.value?.to);

    const dispatch = createEventDispatcher();

    const onFromOffsetChange = (e: { currentTarget: HTMLInputElement }) => {
        updateFromOffset(Number.parseInt(e.currentTarget.value, 10));
    };
    const updateFromOffset = (offset: number) => {
        const newField: AutoDateDefinition = {
            ...field,
            value: {
                ...field.value,
                from: { offset },
                to: field.value?.to || null,
            },
        };
        dispatch('change', {
            field: newField,
        });
    };
    const onToOffsetChange = (e: { currentTarget: HTMLInputElement }) => {
        updateToOffset(Number.parseInt(e.currentTarget.value, 10));
    };

    const updateToOffset = (offset: number) => {
        const newField: AutoDateDefinition = {
            ...field,
            value: {
                ...field.value,
                from: field.value?.from || { offset: 0 },
                to: { offset },
            },
        };
        dispatch('change', {
            field: newField,
        });
    };
    const toggleEnabled = () => {
        const newField: AutoDateDefinition = {
            ...field,
            value: isEnabled
                ? null
                : {
                      ...field.value,
                      from: { offset: 0 },
                      // since we do not know if we should toggle into range or
                      // single offset, it doesn't really matter if we pass
                      // `null` or `{offset: 0}`. The value will be corrected if
                      // needed via AutoDate's `applySettingDependency` (which
                      // may cause filckering in the ui)
                      to: { offset: 0 },
                  },
        };
        dispatch('change', {
            field: newField,
        });
    };
</script>

<label class="checkbox-input">
    <input type="checkbox" checked={isEnabled} onclick={toggleEnabled} />
    Enable autodate
</label>
{#if isEnabled}
    <div>
        <label>
            {isRange ? 'From offset' : 'Offset'}:
            <input
                class="offset"
                type="number"
                disabled={field.changeable === false}
                value={fromOffset}
                oninput={onFromOffsetChange}
                onblur={() => {
                    Number.isNaN(fromOffset) && updateFromOffset(0);
                }}
            />
        </label>
    </div>
    {#if isRange}
        <div>
            <label>
                To offset:
                <input
                    class="offset"
                    type="number"
                    disabled={field.changeable === false}
                    value={toOffset}
                    oninput={onToOffsetChange}
                    onblur={() => Number.isNaN(toOffset) && updateToOffset(0)}
                />
            </label>
        </div>
    {/if}
{/if}

<style lang="scss" scoped>
    .offset {
        width: 100%;
    }
    label {
        font-size: 14px;
    }
    .checkbox-input {
        display: flex;
        align-items: center;
        input {
            margin-left: 0;
        }
    }
</style>
